"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.text_encoder = void 0;
let cs_text_encoder = undefined;
function text_encoder() {
    if (cs_text_encoder == undefined) {
        if (typeof window === 'undefined') {
            // Node
            cs_text_encoder = new TextEncoder();
        }
        else {
            cs_text_encoder = new window.TextEncoder();
        }
    }
    return cs_text_encoder;
}
exports.text_encoder = text_encoder;
//# sourceMappingURL=text_encoder.js.map